import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import './Header.scss';
import type { HeaderProps } from '../../types';
import { useAuth } from '../../contexts/auth';
import Settings from '../../api/Settings';

const ProductionApiUrl = 'https://api.pathta.io';
const isProduction = Settings.api_url?.replace(/\/+$/, '') === ProductionApiUrl;

export default function Header({ menuToggleEnabled, title, toggleMenu }: HeaderProps) {
  const { signOut, sessionDetail } = useAuth();
  let notificationText = sessionDetail?.NotificationMessage ?? "";
  let notificationClass = sessionDetail?.NotificationClass ?? "";
  return (
    <header className={isProduction ? 'header-component' : 'header-component header-non-production'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}              >
            <img src="svgs/logo.svg" alt="Kitten" height="28" />
        </Item>
          {(notificationText !== "") && 
            <Item location={'center'}>
                <div className={notificationClass}>{notificationText}</div>
            </Item>
          }
        <Item
          location={'after'}>
          <Button
            type="normal"
            stylingMode="outlined"
            icon='./svgs/logout.svg'
            text='Log out'
            onClick={signOut}
          />
        </Item>
      </Toolbar>
    </header>
)}
